import { customer360Service } from '../../helpers/services/customer360.service'
import { sharedHelper } from '@/utils'

export const state = {
  details: {},
  status: { detail: true },
}

export const CUSTOMER_360_MODULE = 'customer360'

export const GET_CUSTOMER_360 = 'getCustomer360'
export const DOWNLOAD_STATEMENT = 'downloadStatement'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const DETAIL_SUCCESS = 'detailSuccess'
const RESET = 'reset'

export const actions = {
  [GET_CUSTOMER_360]({ commit }, { debtorCode }) {
    commit(REQUESTING, 'detail')
    return customer360Service.getCustomer360(debtorCode).then((r) => {
      commit(DETAIL_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [DOWNLOAD_STATEMENT](_ctx, { debtorCode }) {
    return customer360Service.statementPdf(debtorCode).then((blob) => {
      const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }))
      const a = document.createElement('a')
      a.href = url
      a.download = `statement_${debtorCode}.pdf`
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
}

export const mutations = {
  [DETAIL_SUCCESS](state, data) {
    state.details = data?.data || {}
  },
  [FAILURE](state) { state.status = { detail: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { detail: true } },
  [RESET](state) { state.details = {}; state.status = { detail: true } },
}
